/* eslint-disable react/jsx-max-depth */
import type { ReactElement } from 'react';

import { RESOLVER_CONTENT_CLASSNAME } from '@e-socna/printer-contract';

import type {
  ResolverParameters,
  ResolverResult,
} from '../types/resolvers.type';

export const useDevisAcceptationCGV = ({
  enabled,
}: Readonly<ResolverParameters>): ResolverResult<ReactElement> => {
  if (!enabled) {
    return {
      data: undefined,
      error: null,
      isSuccess: false,
      isLoading: false,
    };
  }

  const generated = (
    <div className={RESOLVER_CONTENT_CLASSNAME}>
      <p>
        Le client déclare accepter expressément les conditions générales
        retranscrites ci-après.
      </p>
      <table
        border={1}
        style={{
          borderCollapse: 'collapse',
          width: 'calc(100% - 4px)',
          borderWidth: '2px',
        }}
      >
        <colgroup>
          <col style={{ width: '49.9298%' }} />
          <col style={{ width: '49.9298%' }} />
        </colgroup>
        <tbody>
          <tr>
            <td style={{ borderWidth: '2px', paddingLeft: '8px' }}>
              <div style={{ textAlign: 'center' }}>
                BON POUR ACCORD
                <br />
                Pour le client :
              </div>
              <br />
              <br />
              Fait à
              ................................................................................
              <br />
              <br />
              Le&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              ................................................................................
            </td>
            <td
              style={{
                verticalAlign: 'top',
                textAlign: 'center',
                borderWidth: '2px',
              }}
            >
              Adresse de facturation
              <br />
              <em>Si différente</em>
            </td>
          </tr>
          <tr>
            <td style={{ textAlign: 'center', borderWidth: '2px' }}>
              <br />
              <br />
              <br />
              <br />
              <em>(Date, Tampon + visa)</em>
            </td>
            <td style={{ borderWidth: '2px', textAlign: 'center' }}>
              ...........................................................................................
              <br />
              <br />
              ...........................................................................................
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );

  return {
    data: { generated },
    error: null,
    isSuccess: true,
    isLoading: false,
  };
};
